<template>
  <div>
    <v-card flat>
      <v-form @submit.prevent="sendSMS" v-model="isFormValid" ref="form">
        <v-card-text class="ml-4">Input Numbers</v-card-text>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title class="ml-0"
                  >Mobiles[{{ phoneNumbersArray.length }}]</v-card-title
                >
                <v-card-text
                  ><v-textarea
                    v-model="phoneNumbersInput"
                    :rules="phoneNumberRules"
                    outlined
                    name="input-6-4"
                    placeholder="Enter or paste Mobile Number(s) separated by a comma."
                  ></v-textarea
                  ><v-alert text prominent color="primary" icon="mdi-dialpad">
                    Enter or paste <strong>Mobile Number(s)</strong> separated
                    by a comma <strong>e.g</strong> 0708400000,0726770792
                  </v-alert></v-card-text
                >
              </v-card></v-flex
            >
            <v-flex xs12 md6
              ><v-card flat>
                <v-card-title>Compose SMS</v-card-title>
                <v-card-text>
                  <v-select
                    v-model="selectedTemplate"
                    :items="templateOptions"
                    label="Select a template"
                    outlined
                    dense
                  ></v-select>
                  <v-textarea
                    v-model="selectedTemplateMessage"
                    :counter="300"
                    :rules="messageRules"
                    outlined
                    name="input-7-4"
                    label="Message"
                    placeholder="Type your message here (avoid emoji)."
                    dense
                  ></v-textarea>
                  <v-divider></v-divider>
                  <v-select
                    v-model="selectedSenderId"
                    class="mt-4"
                    :items="senderIdOptions"
                    label="--Select SenderID--"
                    outlined
                    dense
                    :rules="senderIdRules"
                  ></v-select>
                  <v-checkbox
                    v-model="checkbox"
                    label="Schedule this message"
                  ></v-checkbox>
                  <v-btn
                    v-if="!checkbox"
                    class="primary white--text lowercase-text"
                    plain
                    :loading="$store.state.loading.sendBtn.load"
                    :disabled="$store.state.loading.sendBtn.disabled"
                    type="submit"
                  >
                    Send Now
                  </v-btn>
                </v-card-text>
              </v-card></v-flex
            ></v-layout
          >
        </v-card-text>
      </v-form>
    </v-card>
    <DialogSchedule
      @close="checkbox = false"
      v-if="checkbox"
      :phoneNumbersArray="phoneNumbersArray"
      :selectedTemplateMessage="selectedTemplateMessage"
      :selectedSenderId="selectedSenderId"
    />
  </div>
</template>

<script>
import DialogSchedule from "../Dialogs/ScheduleDialog";
export default {
  props: ["templates", "senderIds"],
  components: { DialogSchedule },
  data: () => ({
    phoneNumbersInput: "",
    phoneNumbersArray: [],
    selectedTemplate: null,
    selectedTemplateMessage: "", // Initialize selectedTemplateMessage
    selectedSenderId: null,
    senderIdRules: [(v) => !!v || "Sender ID is required"],
    isFormValid: false,
    phoneNumberRules: [(v) => !!v || "Phone number(s) is required"],
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => v.length <= 300 || "Message must be 160 characters or fewer",
    ],
    checkbox: false,
  }),
  watch: {
    phoneNumbersInput(newInput) {
      this.phoneNumbersArray = newInput
        .split(",")
        .map((number) => number.trim())
        .filter((number) => number !== "");
    },
    selectedTemplate() {
      // Clear customMessage when a template is selected
      const selectedTemplate = this.templates.find(
        (template) => template.name === this.selectedTemplate
      );
      this.selectedTemplateMessage = selectedTemplate
        ? selectedTemplate.message
        : "";
      this.customMessage = "";
    },
  },
  computed: {
    templateOptions() {
      return this.templates.map((template) => template.name);
    },

    senderIdOptions() {
      return this.senderIds.map((sender) => sender.senderId);
    },
  },
  methods: {
    async sendSMS() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("send/sendSMS", {
          phoneNumbers: this.phoneNumbersArray,
          senderId: this.selectedSenderId,
          message: this.selectedTemplateMessage,
        });
        this.selectedTemplateMessage = null;
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
